import React from "react";

export const DribbbleFilled = ({ size = 20 }: { size?: number }) => {
  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 4C6.24 4 4 6.24 4 9V41C4 43.76 6.24 46 9 46H41C43.76 46 46 43.76 46 41V9C46 6.24 43.76 4 41 4H9ZM26.1699 11C28.1399 11 30 12.77 30 21.5C30 24.62 29.4691 29.1509 27.6191 32.8809C28.4191 33.9209 29.22 34.25 29.75 34C31.25 33.28 32.2094 30.7502 33.1094 27.9902C33.3594 27.2402 34.1909 26.8305 34.9609 27.0605C35.7409 27.3005 36.1797 28.0998 35.9297 28.8398C35.1697 31.1798 33.0403 36.9805 29.8203 36.9805C28.8003 36.9805 27.4291 36.9402 26.1191 35.6602C24.6491 37.6602 22.8204 39 20.6504 39C16.0604 39 14 35.5108 14 32.0508C14 28.3808 15.8809 24.0508 20.1309 24.0508C20.8509 24.0508 21.5101 24.1809 22.0801 24.3809C22.0001 23.3809 22 22.5809 22 21.3809C22 21.2709 22.0399 11 26.1699 11ZM26.2891 14.0508C25.6791 15.0908 24.9609 18.1291 24.9609 21.3691C24.9609 24.8891 25.3702 27.5898 25.9902 29.5898C26.9202 27.0198 27.0391 24.03 27.0391 21.5C27.0391 16.74 26.7591 14.7108 26.2891 14.0508ZM20.1191 27C16.9391 27 17 31.9291 17 32.1191C17 33.3591 17.2891 36 20.6191 36C21.8991 36 23.2008 34.9797 24.3008 33.1797C23.6308 31.9297 23.0001 29.97 22.5801 28C22.5001 27.94 22.4196 27.8805 22.3496 27.8105C22.3496 27.8105 21.3791 27 20.1191 27Z"
        fill="currentColor"
      />
    </svg>
  );
};
